import { DialogContentText, Stack } from "@mui/material";
import Grid from "@mui/material/Grid";
import {
  ButtonType,
  StyledButton,
} from "@stories/atoms/StyledButton/StyledButton";
import { AddIcon } from "assets/constants";
import {
  ConditionLineItem,
  ShareConditionLineItem,
} from "permit-one-common/src/interfaces/condition";
import { ConditionCommentLineItem } from "permit-one-common/src/interfaces/conditionComment";
import { PermitLineItem } from "permit-one-common/src/interfaces/permit";
import { ProfileLineItem } from "permit-one-common/src/interfaces/profile";
import { ProjectLineItem } from "permit-one-common/src/interfaces/project";
import { useCallback, useState } from "react";

import AddCommentModal from "./AddCommentModal";
import { CommentTable2 } from "./CommentTable2";
import { Header, HeaderButtonType } from "../Header/Header";

interface ConditionCommentFormProps {
  loading: boolean;
  disabled: boolean;
  canEdit: boolean;
  project?: ProjectLineItem;
  permit?: PermitLineItem;
  condition?: ConditionLineItem;
  userProfile?: ProfileLineItem;
  shareCondition?: ShareConditionLineItem;
  comments: ConditionCommentLineItem[];
  createComments: (comments: ConditionCommentLineItem[]) => void;
  deleteComment: (comment: ConditionCommentLineItem) => void;
  handleSubmit: () => void;
  handleBack: () => void;
  handleClose: () => void;
}

export const ConditionCommentForm = ({
  canEdit,
  comments,
  condition,
  createComments,
  deleteComment,
  disabled,
  handleBack,
  handleClose,
  handleSubmit,
  loading,
  permit,
  project,
  shareCondition,
  userProfile,
}: ConditionCommentFormProps) => {
  const [open, setOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  // Handle Table record Search
  const handleSearchChange = async (searchTerm: string) => {
    setSearchTerm(searchTerm);
  };

  const handleAddComment = useCallback(async () => {
    setOpen(true);
  }, [open]);

  const buttons = [
    {
      action: handleAddComment,
      buttonType: "button",
      icon: <AddIcon variant="secondary" />,
      text: "Add Comment",
      type: HeaderButtonType.PRIMARY,
      width: 160,
    },
  ];

  return (
    <>
      <DialogContentText
        mt={2}
        sx={{
          color: "black",
          fontSize: "14px",
          lineHeight: "16px",
          padding: "0 0 10px",
        }}
      >
        <Header
          mainTitle={"Comments"}
          subTitle={
            canEdit
              ? "Add comments for the condition"
              : "View comments for the conditon"
          }
          loading={loading}
          handleSearchChange={handleSearchChange}
          searchTerm={searchTerm}
          buttons={buttons}
        />
      </DialogContentText>
      <Grid container sx={{ padding: "0 " }}>
        <Grid item xs={12} md={12} sx={{ padding: "0 0 20px" }}>
          <CommentTable2
            canEdit={canEdit}
            loading={loading}
            disabled={disabled}
            searchTerm={searchTerm}
            conditionComments={comments}
            deleteComment={deleteComment}
          />
        </Grid>
        <Grid
          item
          sm={12}
          md={12}
          sx={{
            display: "flex !important",
            justifyContent: "right !important;",
          }}
        >
          <Stack direction={"row"} spacing={2}>
            <StyledButton
              loading={false}
              btnType={ButtonType.Secondary}
              onClick={handleBack}
            >
              Back
            </StyledButton>
            <StyledButton
              loading={false}
              btnType={ButtonType.Secondary}
              onClick={handleClose}
            >
              Exit
            </StyledButton>
            <StyledButton loading={false} type="submit" onClick={handleSubmit}>
              Continue
            </StyledButton>
          </Stack>
        </Grid>
      </Grid>
      {open && project && permit && condition ? (
        <AddCommentModal
          open={open}
          disabled={disabled}
          project={project}
          permit={permit}
          condition={condition}
          userProfile={userProfile}
          shareCondition={shareCondition}
          setOpen={setOpen}
          createComments={createComments}
        />
      ) : null}
    </>
  );
};
